<template lang="pug">
  auth-layout
    #sign-up.view
      transition
        auth-body(v-show='show' key='auth-body')
          form.sign-up-form(@submit.prevent='sign_up')
            fieldset
              bf-input
                template(slot='icon')
                  img(src='/ui/email-icon.png')
                input( required type='email' :placeholder='$t("Email")' v-model='email' )

              bf-input
                template(slot='icon')
                  img(src='/ui/password-icon.png')
                input( 
                  :placeholder='$t("Password")'
                  required :type='type'  
                  v-model='password' 
                  minlength='8' 
                  title='Must contain at least 1 capital letter and 1 symbol' 
                  pattern='(?=.*?[#?!@$%^&*-+~@])(?=.*[A-Z]).{8,}'
                )
                template(slot='reveal')
                  img(v-if="type=='password'" src='/ui/eyeopen.svg' width="30" @click='showPassword')
                  img(v-else src='/ui/eyeclose.svg' width="30" @click='showPassword')  

              bf-input
                template(slot='icon')
                  img(src='/ui/password-icon.png')
                input( required :type='type' :placeholder='$t("Confirm Password")' v-model='confirm' )
              
              ol.rule
                li {{$t("Minimum of 8 characters")}}
                li {{$t("At least 1 capital letter and 1 symbol")}}
                li {{$t("A symbol is DEFINED as one of these characters")}}:  * # ? ! @ $ % ^ & * - + ~ @

              bf-input
                template(slot='icon')
                  img(src='/ui/referral-icon.png')
                input( type='text' :placeholder='$t("Referral ID")' :value='$route.params.uid' disabled )
              
              bf-flex.centered
                bf-button.large.combo.solid.submit(type='submit')
                  template(slot='text') {{ $t('Sign Up') }}
</template>

<script>
  import { auth, db } from '@/main'
  import { Authenticable } from '@/mixins/authenticable'
  import AuthLayout from '@/layouts/auth'
  import AuthBody from '@/components/auth-body'
  import TermsPolicy from '@/components/terms-policy'

  import { Animatable } from '@/mixins/view'

  export default {
    name: 'sign-up-link.view',

    mixins: [ Authenticable, Animatable ],

    components: {
      AuthLayout,
      AuthBody,
      TermsPolicy
    },

    data() {
      return {
        email: '',
        password: '',
        confirm: '',
        show: false,
        acc: null,
        type: 'password'
      }
    },

    firestore() {
      return {
        acc: db.collection( 'accounts' ).doc( this.$route.params.uid )
      }
    },

    methods: {
      sign_up() {
        if ( this.confirm == this.password )
          auth.createUserWithEmailAndPassword( this.email, this.password ).then( doc => {
            db.collection( 'referrals' ).add({
              type: 'friend', // 'invite merchants'
              by: this.acc,
              on: new Date(),
              uid: doc.user.uid,
              to: { email: this.email }
            }).then( () => this.$router.push({ name: 'onboarding' }) )
          }).catch( e => this.message = e )
        else
          this.message = this.$t('Password and confirmation does not match')
      },
      showPassword() {
        if( this.type == 'password') {
          this.type = 'text'
        } else {
          this.type = 'password'
        }
      }
    },
  }
  
</script>

<style scoped lang='stylus'>
  ol
    font-size .8em
    margin-left 20px
    list-style-type lower-alpha

  .bf-button.submit
    margin-top 20px
</style>